export const STOP="STOP";
export const START="START";